import React, { useContext, useState, useEffect, useRef } from 'react';
import { Table, Input, notification, Popconfirm, Form, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons'
const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef();
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async e => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
  }

  return <td {...restProps}>{childNode}</td>;
};

class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        width: '30%',
        render: (text, record) =>
          {
          return (record.transferFail ?
             <div> {text} <br />  <label style={{color: 'red'}}> Available: {record.availableQty} </label> </div>
             :
            <div> {text} <br />  <label style={{ color: 'green' }}> Available: {record.availableQty} </label> </div>
            )
          }
      },
      {
        title: 'Qty',
        dataIndex: 'qty',
        editable: true,

      },
      {
        title: '',
        dataIndex: 'operation',
        render: (text, record) =>
          this.props.dataSource.length >= 1 ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record.key)}>
              <a> <DeleteOutlined /> Delete</a>
            </Popconfirm>
          ) : null,
      },
    ];
    // this.state = {
    //   dataSource: [
    //     {
    //       key: '0',
    //       name: 'Edward King 0',
    //       qty: '32',
    //       available:  100,
    //     },
    //     {
    //       key: '1',
    //       name: 'Edward King 1',
    //       qty: '32',
    //       available: 450,
    //     },
    //   ],
    //   count: 2,
    // };
  }

  handleDelete = key => {
    this.props.deleteHandler(key)

  };

  handleSave = row => {
    const newData = [...this.props.dataSource];
    
    // debugger
    //todo: row.qty
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    if (parseFloat(item.availableQty) < parseFloat(newData.qty))
    {
      notification['error']({
        message: 'Error',
        placement: "bottomLeft",
        description:
          'Invalid Qty. Should be equal to or less than Available Qty',
      });
      return false;
    }
    else{
      newData.splice(index, 1, { ...item, ...row });
      this.props.updateHandler(newData)
    }
  };

  render() {
    const { dataSource } = this.props;
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };
    const columns = this.columns.map(col => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });
    return (
      <div>

        <Table
          components={components}
          rowClassName={() => 'editable-row'}
          bordered
          dataSource={dataSource}
          columns={columns}
          pagination={{ hideOnSinglePage: true}}
        />
      </div>
    );
  }
}

export default EditableTable;